'use client';

import { c as _c } from "react/compiler-runtime";
import { AutoCompleteKeyword } from '@/features/search/ui';
import { useSearchUiStore } from '@/features/search/model/ui/store';
import { useQueryAutoComplete } from '@/entities/search/hooks/useSearch';
import { AutoCompleteResponse } from '@/shared/types/type/search';
const AutoComplete = () => {
  const $ = _c(7);
  const {
    keyword
  } = useSearchUiStore();
  let t0;
  if ($[0] !== keyword) {
    t0 = {
      query: keyword
    };
    $[0] = keyword;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data
  } = useQueryAutoComplete(t0);
  let t1;
  if ($[2] !== data || $[3] !== keyword) {
    t1 = data?.map(item => <AutoCompleteKeyword key={item.id} keyword={keyword} autoCompleteKeyword={item.hospitalNameKo} />);
    $[2] = data;
    $[3] = keyword;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="flex flex-col px-4">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default AutoComplete;